<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="ded">
<p class="ct"><a class="xref" href="#/OEBPS/pppjusticedamned0006#toc">Dedication</a></p>
<p class="ded">To Peter Goodhugh with gratitude<br class="calibre1"/>for your kindness and help from the beginning.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-justicedamned0005.vue?4ad0f44b